export function offerAllowed({ subscribed, dismissed, shown, now = Date.now(), cooldown = 14 }) {
  return !subscribed && !shown && (!Number.isFinite(Number(dismissed)) || !dismissed || now - Number(dismissed) >= cooldown * 86400000);
}

export function newsletterPayloadIsValid(form) {
  return form.checkValidity() && form.querySelector('[type="checkbox"]')?.checked === true;
}

if (typeof document !== 'undefined') {
  const root = document.querySelector('[data-tn-newsletter]');
  const dialog = root?.querySelector('dialog');
  if (dialog && typeof dialog.showModal === 'function' && !/^\/(cart|checkout|checkouts|account|challenge)(\/|$)/.test(location.pathname)) {
    const launcher = root.querySelector('[data-newsletter-open]');
    const form = root.querySelector('form');
    const prefix = 'tn-newsletter-v1:';
    const storage = (area, method, key, value) => { try { return window[area][method](prefix + key, value); } catch { return null; } };
    let shown = storage('sessionStorage', 'getItem', 'shown') === '1';
    let subscribed = storage('localStorage', 'getItem', 'subscribed') === '1';
    let dismissed = storage('localStorage', 'getItem', 'dismissed');
    let restoreFocus = null;
    let submitting = false;
    const emit = (action) => {
      // No email, name or other personal information is included in measurement events.
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
        window.Shopify.analytics?.publish?.('tn_newsletter_' + action, { popup_id: 'tn-newsletter-v1' });
      }
    };
    const open = (manual = false) => {
      if (dialog.open || document.hidden || document.querySelector('dialog[open]')) return;
      if (!manual && (!offerAllowed({ subscribed, dismissed, shown, cooldown: Number(root.dataset.cooldown) }) || window.Shopify?.designMode)) return;
      restoreFocus = document.activeElement;
      dialog.showModal();
      shown = true;
      storage('sessionStorage', 'setItem', 'shown', '1');
      launcher.hidden = true;
      emit('view');
    };
    const close = () => {
      if (!dialog.open) return;
      dismissed = String(Date.now());
      storage('localStorage', 'setItem', 'dismissed', dismissed);
      dialog.close();
      launcher.hidden = subscribed;
      restoreFocus?.focus?.({ preventScroll: true });
      emit('dismiss');
    };
    root.querySelectorAll('[data-newsletter-close]').forEach(button => button.addEventListener('click', close));
    launcher.addEventListener('click', () => open(true));
    dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) close(); } });
    dialog.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button:not([disabled]), input:not([type="hidden"]), a[href]')].filter(el => el.getClientRects().length > 0);
      const first = controls[0], last = controls.at(-1);
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    form?.addEventListener('submit', event => {
      if (submitting || !newsletterPayloadIsValid(form)) { event.preventDefault(); form.reportValidity(); return; }
      if ([...form.querySelectorAll('input[type="text"]')].some(input => !input.value.trim())) { event.preventDefault(); const error = form.querySelector('[data-newsletter-client-error]'); error.textContent = 'Lütfen adınızı ve soyadınızı yazın.'; error.hidden = false; return; }
      submitting = true;
      const submit = form.querySelector('[type="submit"]');
      submit.disabled = true;
      submit.querySelector('span').textContent = 'Talebiniz gönderiliyor…';
      emit('submit');
      // Shopify's native customer form owns validation, CAPTCHA, opt-in and persistence.
      // A submit attempt never counts as a successful subscription.
    });
    window.addEventListener('pageshow', () => { submitting = false; const submit = form?.querySelector('[type="submit"]'); if (submit) { submit.disabled = false; submit.querySelector('span').textContent = submit.dataset.originalLabel || submit.querySelector('span').textContent; } });
    const submit = form?.querySelector('[type="submit"]');
    if (submit) submit.dataset.originalLabel = submit.querySelector('span').textContent;
    const result = root.querySelector('[data-newsletter-result]');
    if (result?.dataset.newsletterResult === 'success') {
      subscribed = true;
      storage('localStorage', 'setItem', 'subscribed', '1');
      open(true);
      result.focus();
      emit('success');
    } else if (result?.dataset.newsletterResult === 'error') open(true);
    else launcher.hidden = subscribed;
    const started = Date.now();
    const attempt = () => {
      const elapsed = Date.now() - started;
      const scrollable = document.documentElement.scrollHeight - innerHeight;
      if (elapsed >= Number(root.dataset.delay) * 1000 || (elapsed >= 15000 && scrollable > 0 && scrollY / scrollable >= .35)) open();
    };
    if (!subscribed) {
      setTimeout(attempt, Number(root.dataset.delay) * 1000);
      document.addEventListener('scroll', attempt, { passive: true });
      document.addEventListener('visibilitychange', attempt);
    }
    document.addEventListener('shopify:section:select', event => { if (event.target?.contains(root)) open(true); });
  }
}
